import PropTypes from 'prop-types'
import { iso8601PropType } from '../common/iso-8601-prop-type'

/**
 * @typedef {Object} ObjectRecurringCustomerBooking
 * @property {string} [category] - The internal feature name
 * @property {string} [stringCode] - The feature name string code for translation
 * @property {ISO8601} [validFrom] - From when the feature is booked
 * @property {ISO8601} [validTo] - Until when the feature is booked
 */
export const objectRecurringCustomerBookingPropType = PropTypes.shape({
    category: PropTypes.string,
    stringCode: PropTypes.string,
    validFrom: iso8601PropType,
    validTo: iso8601PropType
})
